// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.singlefamilyenterprise.RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserSingleFamilyEnterpriseContractsResponseWebDto } from '../..';

export const RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_Path =
  '/api/web/v1/users/singleFamilyEnterprise/contracts';

/**
 * Get active single family enterprise contracts for the user
 */
export const RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserSingleFamilyEnterpriseContractsResponseWebDto>(
    {
      endpoint: RentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
